<template>

  <div class="height-100">
    <creating
      v-if="creating"
      height="100%" />
    <VideoEmbed
      v-else
      :roomId="token" />
  </div>

</template>

<script>
import VideoEmbed from './VideoEmbed.vue'

export default {
  name: 'Meet',
  components: {
    VideoEmbed
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    callUrl () {
      return `https://quickin.daily.co/novoteste`
    }
  },
  mounted () {
    this.getContext()
  },
  methods: {
    async getContext () {
      try {
        const res = await this.$store.dispatch('getMeetcontext', { token: this.token })
        const {
          job_id: jobId,
          candidate_id: candidateId,
          account_id: accountId
        } = res

        // seleciona conta
        await this.$store.dispatch('selectAccount', accountId)

        // verifica se tem acesso a vaga
        await this.$store.dispatch('getJobById', jobId)

        this.$router.push(`/job/${jobId}?candidate_id=${candidateId}&candidate_job_id=${jobId}`)
      } catch (error) {
        console.error('Erro ao obter contexto da reunião:', error)
        this.creating = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Meet/Meet.vue